import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import config from 'config';
import navModule, { loadNav } from './navModule';
import logger from './logger';
var debug = logger.extend('navExtension');
export default function navExtension() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      globalPrefetchNavs = _ref.globalPrefetchNavs;

  return registry => ({
    id: 'navigation',
    server: process.browser ? {} : {
      init() {
        require('./config');
      }

    },

    page(_ref2) {
      var _ref2$prefetchNavs = _ref2.prefetchNavs,
          prefetchNavs = _ref2$prefetchNavs === void 0 ? [] : _ref2$prefetchNavs;

      if (config.has('public.navigation.globalPrefetchNavs')) {
        // eslint-disable-next-line no-console
        console.warn('Config option public.navigation.globalPrefetchNavs has been deprecated, please migrate to the globalPrefetchNavs option on navExtension.');
      }

      var getPrefetchNavs = registry.utils.getMergedArrayOption({
        globalPrefetchNavs,
        prefetchNavs
      });
      return {
        getInitialProps(ctx) {
          return _asyncToGenerator(function* () {
            var _yield$getPrefetchNav = yield getPrefetchNavs(ctx),
                _yield$getPrefetchNav2 = _slicedToArray(_yield$getPrefetchNav, 2),
                prefetchNavs = _yield$getPrefetchNav2[0],
                meta = _yield$getPrefetchNav2[1];

            if (prefetchNavs.length) {
              debug('Prefetching %s %s added by %s.', prefetchNavs.length, prefetchNavs.length === 1 ? 'nav' : 'navs', meta.sources.join(', '));
              yield ctx.store.dispatch(loadNav(prefetchNavs));
            }
          })();
        }

      };
    },

    redux: {
      modules: [navModule]
    }
  });
}